// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_5s-0";